import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const steps = [
  { n: "01", title: "Sign Up Free", body: "Anyone can create a free Hunt57 account. No invite code, no waiting list. Just email, username, password." },
  { n: "02", title: "Browse & Buy", body: "Search the marketplace by player, year, brand, set, variation, grade, and more. Message sellers, favorite listings, and buy directly." },
  { n: "03", title: "Get a Vendor Invite", body: "Selling is invite-only. Ask a current Hunt57 vendor for a referral code — trusted collectors invite trusted collectors." },
  { n: "04", title: "Upgrade to Vendor", body: "Go to Account → Switch to Vendor Account. Add a credit card and either apply or enter a referral code. First 30 days of vendor membership are free — cancel any time during the trial." },
  { n: "05", title: "List Your Cards", body: "Add payment paths (PayPal, Cash App, Venmo). Upload front & back photos. Titles auto-generate from player, year, brand, set, parallel, grade." },
  { n: "06", title: "Buyer Pays You Directly", body: "Payment happens outside Hunt57 — buyer taps your PayPal or Cash App link. Hunt57 never touches card-sale money. 0% selling fees." },
  { n: "07", title: "Confirm the Sale", body: "Both sides confirm the transaction. You mark shipped, buyer marks received, and you both rate each other. Reputation is everything." },
];

export default function HowItWorks() {
  return (
    <div className="min-h-screen text-white font-body">
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <Link to="/" data-testid="how-back-home" className="inline-flex items-center">
          <Logo variant="nav" alt="Hunt57" />
        </Link>
        <h1 className="mt-6 font-display font-black uppercase text-4xl md:text-6xl tracking-tighter leading-none">How It Works</h1>
        <p className="mt-6 text-lg text-zinc-400 leading-relaxed max-w-2xl">
          Hunt57 is free to browse and buy. Selling is invite-only. Money always moves directly between buyer and seller.
        </p>
        <div className="mt-12 space-y-4">
          {steps.map((s) => (
            <div key={s.n} className="h57-surface p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start" data-testid={`how-step-${s.n}`}>
              <div className="font-display font-black text-5xl md:text-6xl text-[#FF5F1F] tracking-tighter leading-none min-w-[80px]">{s.n}</div>
              <div>
                <h3 className="font-display font-black uppercase text-xl md:text-2xl tracking-tight">{s.title}</h3>
                <p className="mt-3 text-zinc-400 leading-relaxed">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col sm:flex-row gap-4">
          <Link to="/register" className="h57-btn-primary text-center" data-testid="how-cta-signup">Sign Up Free</Link>
          <Link to="/login" className="h57-btn-secondary text-center" data-testid="how-cta-signin">Sign In</Link>
        </div>
        <div className="mt-3 font-mono text-[11px] text-zinc-500 tracking-widest uppercase">
          → Free account to browse & buy. Vendor upgrade requires a referral code.
        </div>
      </div>
    </div>
  );
}
